import React, { useState, useEffect, useRef } from 'react'
import models from '../modelsImport'
import { useSelector, useDispatch } from 'react-redux'
import { setARStarted } from '../../../redux/reducers/models'
import '@google/model-viewer'
import '../../../styles/components/RenderAR.scss'
import ObjectBtn from './ObjectBtn'

const ModelViewer = () => {
  const { selectedId, questions } = useSelector((state) => state.models)
  const dispatch = useDispatch()

  const [selectedModel, setSelectedModel] = useState(models[0])
  const hiddenArButtonRef = useRef(null)
  const [isButtonVisible, setIsButtonVisible] = useState(false)
  const [inAR, setInAR] = useState(false)

  useEffect(() => {
    setSelectedModel(models.find(({ id }) => id === selectedId))
  }, [selectedId])

  const handleClick = () => {
    hiddenArButtonRef.current.click()
    setInAR(true)
  }

  useEffect(() => {
    const arBtn = document.getElementById('main-ar-btn')

    if (arBtn) {
      const observer = new IntersectionObserver((entries) => {
        setIsButtonVisible(entries.some(entry => entry.isIntersecting))
      }, { threshold: 1.0 })

      observer.observe(arBtn)
      return () => observer.unobserve(arBtn)
    }
  }, [])

  useEffect(() => {
    if (inAR) {
      const timer = setTimeout(() => dispatch(setARStarted(true)), 5000)
      return () => clearTimeout(timer)
    }
  }, [dispatch, inAR, questions])

  return (
    <div className="cards" id="card" data-testid="card">
      <model-viewer
        src={selectedModel.androidModel}
        poster={selectedModel.poster}
        ios-src={selectedModel.iosModel}
        shadow-intensity="1"
        camera-controls
        auto-rotate
        ar
      >
        <button
          ref={hiddenArButtonRef}
          className="main-ar-button"
          slot="ar-button"
          id="main-ar-btn"
          data-testid="ar-button"
        >
          START
        </button>
      </model-viewer>

      {isButtonVisible && (
        <button className="custom-ar-button" data-testid="custom-ar-button" onClick={handleClick}>
          <ObjectBtn />
          <span>start</span>
        </button>
      )}
    </div>
  )
}

export default ModelViewer
